import { toast } from 'vue-sonner'

// Shoelace alert variants -> Sonner toast types. The <Toaster> lives in App.vue.
const TOAST_BY_VARIANT = {
  primary: toast.info,
  brand: toast.info,
  info: toast.info,
  success: toast.success,
  warning: toast.warning,
  danger: toast.error,
  error: toast.error
}

export function useNotification() {
  function showNotification({
    message = 'Default message text',
    variant = 'success',
    icon = 'info-circle',
    duration = 6000,
    closable = true,
    bubbles = true
  }) {
    const app = document.getElementById('app')
    const event = new CustomEvent('showNotification', {
      bubbles,
      detail: {
        message,
        variant,
        duration,
        icon,
        closable
      }
    })
    app.dispatchEvent(event)
  }

  function notify(broadcastMessage) {
    const defaultMessage = {
      message: 'Message Text',
      variant: 'brand',
      duration: 3000
    }
    const { variant, duration, message } = {
      ...defaultMessage,
      ...broadcastMessage
    }
    const show = TOAST_BY_VARIANT[variant] ?? toast.message
    return show(message, { duration })
  }

  function setNotificationEvent() {
    window.addEventListener('showNotification', (e) => notify(e.detail))
  }

  return { notify, showNotification, setNotificationEvent }
}
